import { PageNotFoundComponent } from '../auth/page-not-found/page-not-found.component';
import { LoginComponent } from '../auth/login/login.component';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AuthService } from './services/auth.service';
import { ReactiveFormsModule } from '@angular/forms';
import { AuthGuard } from './guards/auth.guard';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpInterceptorService } from './interceptors/http-interceptor.service';

@NgModule({
  declarations: [
    LoginComponent,
    PageNotFoundComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  providers: [
    {
      provide:  HTTP_INTERCEPTORS, 
      useClass: HttpInterceptorService,
      multi: true
    },
    AuthService,
    AuthGuard
  ]
})
export class SharedModule { }
